import { dateFromIso } from '../../../utils/dates';
import { devWorkingDays } from '../../../utils/planning';

// Barres empilées en couloirs (« lanes ») : hauteur d'un couloir, écart, marge verticale.
export const LANE_H = 34;
export const LANE_GAP = 4;
export const PAD_V = 7;
const DAY_MS = 86400000;

export const laneTop = (lane) => PAD_V + lane * (LANE_H + LANE_GAP);
export const lanesHeight = (nLanes) => nLanes * LANE_H + (nLanes - 1) * LANE_GAP + 2 * PAD_V;

export const overlapsWindow = (a, firstIso, lastIso) => a.fin >= firstIso && a.debut <= lastIso;

// Colonnes de début et de fin d'une période, bornées à la fenêtre affichée.
export function windowIndexes(a, firstIso, lastIso) {
  const startClamp = a.debut < firstIso ? firstIso : a.debut;
  const endClamp = a.fin > lastIso ? lastIso : a.fin;
  const first = dateFromIso(firstIso);
  return {
    sIdx: Math.round((dateFromIso(startClamp) - first) / DAY_MS),
    eIdx: Math.round((dateFromIso(endClamp) - first) / DAY_MS),
  };
}

// Heures par jour et total planifié d'une affectation (jours ouvrés du membre × heures/jour).
export function plannedHours(devs, a) {
  const h = parseFloat(a.heuresParJour || 0) || 0;
  const devForAff = (devs || []).find((d) => d.id === a.devId) || { absences: [] };
  const jours = devWorkingDays(devForAff, dateFromIso(a.debut), dateFromIso(a.fin));
  return { h, totalH: Math.round(jours * h * 10) / 10 };
}

// Bornes d'une sélection par glisser, remises dans l'ordre chronologique.
export const orderedRange = ({ startIso, endIso }) =>
  startIso <= endIso ? [startIso, endIso] : [endIso, startIso];

// Coins arrondis sauf du côté où la barre est coupée par le bord de la fenêtre.
export const barRadiusClass = (truncLeft, truncRight) =>
  `${truncLeft ? '[border-top-left-radius:0] [border-bottom-left-radius:0]' : '[border-top-left-radius:6px] [border-bottom-left-radius:6px]'} ${truncRight ? '[border-top-right-radius:0] [border-bottom-right-radius:0]' : '[border-top-right-radius:6px] [border-bottom-right-radius:6px]'}`;
